Ext.define('SA.view.color.ColorChooser', {
    alias: 'widget.color-chooser',
    extend: 'Ext.Component',

    allowTransparent: false,
    baseCls: 'sa-color-chooser',
    childEls: ['innerEl'],
    overCls: 'sa-color-chooser-over',
    renderTpl: '<div class="{baseCls}-inner" id="{id}-innerEl"></div>',

    autoEl: {
        href: '#',
        tag: 'a'
    },

    afterRender() {
        this.callParent();

        this.setValue(this.value, true);

        this.mon(this.el, 'click', this.onClickHandler, this, {preventDefault: true});
        this.mon(this.el, 'mousedown', this.onMouseDownHandler, this);
    },

    getCssValue() {
        var value = this.value;

        return value ? '#' + value : 'transparent';
    },

    getRefItems() {
        var menu = this.menu;

        if (menu) {
            return [menu];
        }

        return [];
    },

    getValue() {
        return this.value;
    },

    onClickHandler() {
        if (!this.menuShowing) {
            this.menu = SA.view.color.ColorWindow.show({
                allowTransparent: this.allowTransparent,
                color: this.getValue(),
                el: this.el,

                hide: this.onMenuHideHandler,
                select: this.onSelectHandler,
                scope: this
            });
        }
    },

    onMenuHideHandler() {
        this.menu = null;
    },

    onMouseDownHandler() {
        this.menuShowing = !!this.menu;
    },

    onSelectHandler(color) {
        this.setValue(color);
    },

    setValue(value, suppressEvent) {
        var oldValue = this.getValue(),
            innerEl = this.innerEl;

        this.value = value = (value || (this.allowTransparent ? '' : '000000'));

        this.ifCls(value === '', 'sa-color-chooser-transparent');

        if (innerEl) {
            innerEl.setStyle('background-color', this.getCssValue());
        }

        if (!suppressEvent && oldValue !== value) {
            this.fireEvent('change', this, value, oldValue);
        }
    }
});